<template>
  <div>
    <section
      v-if="allowedAccess"
      class="content box-management"
    >
      <div class="row">
        <div class="col-sm-12">
          <div class="box box-default box-solid">
            <div class="box-body">
              <form>
                <div class="row">
                  <select-type
                    class="col-sm-4 col-md-3"
                    name="role"
                    :label="'Rola'"
                    :required="false"
                    :options="roles"
                    :disabled="!rolesLoaded"
                    :empty-first="true"
                    :value="model.role"
                    @input="changeRole"
                  />
                </div>
                <div
                  v-if="model.role !== null"
                  class="row"
                >
                  <div class="col-sm-12">
                    <h2>Przepływy</h2>
                    <list
                      :items="model.transitions"
                      :empty-element="createEmptyElement()"
                      @modified="forceToSave"
                    >
                      <template
                        slot="element"
                        slot-scope="listItems"
                      >
                        <transition-row
                          v-model="listItems.item"
                          :from-states="states"
                          :to-states="states"
                          :itemIndex="listItems.index"
                          :configuration="configuration"
                          @modified="forceToSave"
                        />
                      </template>
                    </list>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
    <save-data-information
      :show="saveDataInformationVisible"
      @close="saveDataInformationVisible = false"
    />
    <login-modal
      :show="loginVisible"
      :back-url-name="`${service}_appraisal_workflow_listing`"
      @close="loginVisible = false"
      @success="init()"
    />
  </div>
</template>

<script>
import Page from '@/components/share/content/Page'
import api from '@/api';
import List from '@/components/share/form/List'
import SelectType from '@/components/share/form/type/SelectType'
import LoginModal from '@/components/bundles/share/modal/LoginModal'
import TransitionRow from '@/components/bundles/share/admin/transition/TransitionRow'
import SaveDataInformation from '@/components/bundles/share/modal/SaveDataInformation'

export default {
  components: {
    TransitionRow,
    SelectType,
    List,
    LoginModal,
    SaveDataInformation
  },
  mixins: [
    Page
  ],
  data () {
    return {
      events: null,
      rolesLoaded: false,
      statesLoaded: false,
      transitionsLoaded: false,
      roles: [],
      states: [],
      headerTitle: { title: 'Mapa przepływu: rzeczoznawczy', description: 'Tryb edycji' },
      loginVisible: false,
      allowedAccess: false,
      model: this.setModel(),
      isSaved: true,
      saveDataInformationVisible: false,
      previouslySelectedRole: null,
      service: this.$route.meta.acl.service,
      workflowName: 'appraisal',
      configuration: []
    }
  },
  computed: {
    roleId () {
      return this.roles.find(r => r.name === this.model.role).id
    }
  },
  created () {
    this.getInitEvents()
  },
  mounted () {
    this.$nextTick(() => {
      this.loginVisible = true
      this.$events.on(this.events.transitionSubmit, this.submitData)
    })
  },
  methods: {
    getInitEvents () {
      this.events = {
        transitionSubmit: `${this.service}:appraisal:transitionSubmit`
      }
    },
    init () {
      this.allowedAccess = true
      this.getConfiguration()
      this.loadRoles()
      this.loadStates()
    },
    setModel () {
      return {
        role: null,
        transitions: []
      }
    },
    createEmptyElement () {
      return {
        label: null,
        fromStates: [[]],
        toStates: [[]],
        metadata: {
          operations: [],
          notifications: [],
          validations: []
        }
      }
    },
    loadRoles () {
      api.request(this.service, 'get', '/roles')
        .then((response) => {
          const roles = response.data
          for (let c = 0; c < roles.length; ++c) {
            this.roles.push({ id: roles[c].id, value: roles[c].name, label: roles[c].label + (roles[c].businessRole ? ' (rola biznesowa)' : ''), name: roles[c].name })
          }
          this.rolesLoaded = true
        })
        .catch(() => {
          this.$notify({
            type: 'error',
            title: 'Wystąpił błąd',
            text: 'Nie można załadować ról'
          })
        })
    },
    loadStates () {
      api.request(this.service, 'get', `/workflows/${this.workflowName}/states`)
        .then((response) => {
          const states = response.data
          for (let c = 0; c < states.length; ++c) {
            this.states.push({ label: states[c].label, value: states[c].name })
          }
          this.statesLoaded = true
        })
        .catch(() => {
          this.$notify({
            type: 'error',
            title: 'Wystąpił błąd',
            text: 'Nie można załadować stanów'
          })
        })
    },
    getConfiguration () {
      api.request(this.service, 'get', `/workflows/2/transitions/configuration`)
        .then((response) => {
          this.configuration = response.data
        })
        .catch(() => {
          this.$notify({
            type: 'error',
            title: 'Wystąpił błąd',
            text: 'Nie można załadować zdarzeń tranzycji'
          })
        })
    },
    forceToSave () {
      this.isSaved = false
    },
    changeRole (optionValue) {
      if (!this.isSaved && this.model.transitions.length > 0) {
        document.getElementById('role').value = this.previouslySelectedRole
        this.saveDataInformationVisible = true
        return
      }

      this.model.role = this.previouslySelectedRole = optionValue

      this.loadTransitions()
    },
    loadTransitions () {
      api.request(this.service, 'get', `/workflows/${this.workflowName}/roles/${this.roleId}/transitions`)
        .then((response) => {
          this.model.transitions = Array.isArray(response.data) ? response.data.map(el => {
            if(el.metadata === null || (Array.isArray(el.metadata) && el.metadata.length === 0) || el.metadata === undefined ) {
              el.metadata = {}
            }
            return el
          }) : []
          this.transitionsLoaded = true
        })
        .catch(() => {
          this.$notify({
            type: 'error',
            title: 'Wystąpił błąd',
            text: 'Nie można załadować przepływów'
          })
        })
    },
    submitData () {
      let submitData = { transitions: [] }
      for (let c = 0; c < this.model.transitions.length; ++c) {
        submitData.transitions.push({
          id: this.model.transitions[c].id ? this.model.transitions[c].id : null,
          name: this.model.transitions[c].label,
          workflow: this.workflowName,
          fromStates: [this.model.transitions[c].fromStates[0].name],
          toStates: [this.model.transitions[c].toStates[0].name],
          metadata: this.model.transitions[c].metadata
        })
      }
      api.request(this.service, 'put', `/workflows/${this.workflowName}/roles/${this.roleId}/transitions`, submitData)
        .then(() => {
          this.isSaved = true
          this.loadTransitions()
          this.$notify({
            type: 'success',
            title: 'Sukces',
            text: 'Dane zapisane poprawnie'
          })
        })
        .catch((error) => {
          this.$notify({
            type: 'error',
            title: 'Wystąpił błąd',
            text: `Błąd zapisu danych: ${error.message}`
          })
        })
    }
  }
}
</script>

<style scoped>
h2 {
    font-size: 18px
}
</style>
